import React from 'react';
import { Link } from 'react-router-dom';
import {ReactComponent as Logo} from '../../assets/images/logo.svg';
const SuluxLogo = () => {
    return(
        <Link to="/" className="c-logo inline-block">
            <Logo/>
        </Link>
    )
}
export default SuluxLogo;